import React from "react";
import CookieBanner from "../components/CookieBanner"; // Adjust the path based on your file structure

const Layout = ({ children }) => {
  return (
    <>
      <CookieBanner />
      {children}
    </>
  );
};

export default Layout;
